module.exports = __webpack_public_path__ + "img/ic-remove-farm.260a37f6.svg";